export default __webpack_public_path__ + "static/media/lionshare.75fd4e24.png";